(function () {
  // The drawer's open state lives on the <details> element, so it still
  // opens and closes without this file. This only adds the conveniences
  // markup alone cannot: closing on backdrop tap, on Escape, and after
  // following a link.
  document.querySelectorAll('[data-menu-drawer]').forEach(function (drawer) {
    function close() {
      drawer.open = false;
    }

    var backdrop = drawer.querySelector('[data-menu-backdrop]');
    if (backdrop) backdrop.addEventListener('click', close);

    drawer.querySelectorAll('[data-menu-close]').forEach(function (button) {
      button.addEventListener('click', close);
    });

    drawer.querySelectorAll('.header__mobile-menu-panel a').forEach(function (link) {
      link.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.open) close();
    });
  });

  // ---------------------------------------------------------------------
  // Disclosures that remember whether the visitor left them open.
  //
  // A <details> resets to its server-rendered state on every navigation, so
  // the catalogue — rendered `open` so the drawer is useful on first contact —
  // would spring back open on the next page even for someone who deliberately
  // collapsed it. Mirroring the state into localStorage keeps the markup's
  // default for a first visit and the visitor's choice after that.
  //
  // No opening happens here: the element is already open in the HTML, so there
  // is nothing to flash. Only a stored "closed" changes anything, and the
  // drawer is shut at this point, so it is never visible either way.
  // ---------------------------------------------------------------------
  document.querySelectorAll('[data-remember-open]').forEach(function (element) {
    var key = 'mm-menu-open:' + element.getAttribute('data-remember-open');

    // Private browsing and blocked storage both throw on access rather than
    // returning null, and a menu is not worth breaking over it.
    var stored = null;
    try {
      stored = localStorage.getItem(key);
    } catch (error) {
      return;
    }

    if (stored === '0') element.open = false;
    if (stored === '1') element.open = true;

    element.addEventListener('toggle', function () {
      try {
        localStorage.setItem(key, element.open ? '1' : '0');
      } catch (error) {
        /* Storage full or denied — the disclosure still works, it just forgets. */
      }
    });
  });

  // ---------------------------------------------------------------------
  // Desktop taxonomy mega menu.
  // Hover opens; a short close delay keeps the panel alive while the pointer
  // crosses the gap between the trigger and the panel. Branches follow hover
  // until the chevron is clicked, which pins them open until clicked again.
  // ---------------------------------------------------------------------
  var CLOSE_DELAY = 180;

  document.querySelectorAll('[data-mega-item]').forEach(function (item) {
    var trigger = item.querySelector('[data-mega-trigger]');
    // The panel is a sibling of <header>, not a descendant of the item, so it
    // can span the full viewport. Everything below therefore has to treat
    // "inside the menu" as "inside the item OR inside the panel".
    var panel = trigger && document.getElementById(trigger.getAttribute('aria-controls'));
    if (!trigger || !panel) return;

    var closeTimer = null;

    function isInside(node) {
      return node instanceof Node && (item.contains(node) || panel.contains(node));
    }

    function openPanel() {
      clearTimeout(closeTimer);
      panel.hidden = false;
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function closePanel() {
      panel.hidden = true;
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');

      // The panel opens showing level 2 only, so reset every branch back to
      // collapsed instead of leaving whatever the last visit expanded.
      panel.querySelectorAll('[data-mega-branch]').forEach(function (branch) {
        branch.classList.add('is-collapsed');
        var toggle = branch.querySelector('[data-mega-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closePanel, CLOSE_DELAY);
    }

    // Hovering either the trigger or the panel keeps it open; the delay
    // covers the pointer travelling from one to the other.
    [item, panel].forEach(function (zone) {
      zone.addEventListener('mouseenter', openPanel);
      zone.addEventListener('mouseleave', scheduleClose);
      zone.addEventListener('focusin', openPanel);
      zone.addEventListener('focusout', function (event) {
        if (!isInside(event.relatedTarget)) closePanel();
      });
    });

    // Touch/pen devices never fire hover, so the first tap opens the panel
    // instead of following the link straight to the catalogue.
    trigger.addEventListener('click', function (event) {
      if (!window.matchMedia('(hover: none)').matches) return;
      if (panel.hidden) {
        event.preventDefault();
        openPanel();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) {
        closePanel();
        trigger.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (!panel.hidden && !isInside(event.target)) closePanel();
    });

    // Branches start expanded, so the chevron is purely a collapse control —
    // no hover behaviour, which would fight the always-open default.
    panel.querySelectorAll('[data-mega-branch]').forEach(function (branch) {
      var toggle = branch.querySelector('[data-mega-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var collapsed = branch.classList.toggle('is-collapsed');
        toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      });
    });
  });
})();
